import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionTag } from "@/components/Reveal";

const services = [
  {
    title: "Blocked Toilet Perth",
    color: "#adff01",
    text: "Toilet won't flush, water rising, gurgling bowl? A blocked toilet is the blockage we clear most. Our drain specialists arrive with everything needed to clear it on the spot — no guessing, no mess left behind.",
  },
  {
    title: "Drain Cleaning Perth",
    color: "#ff66c4",
    text: "Clearing a blockage is half the job. Our 5000 PSI jetter scrubs the inside of your pipework clean, stripping grease and build-up so your drains stay flowing longer — not just until next month.",
  },
  {
    title: "Drain Plumber Perth",
    color: "#169ed9",
    text: "We're not general plumbers having a go. We're a dedicated drainage team that does blocked drains all day, every day — with the specialist jetting, CCTV and locating gear to prove it.",
  },
  {
    title: "Sewer Blockage Perth",
    color: "#adff01",
    text: "More than one fixture draining slowly? That's usually your main sewer line — too severe for a plunger. Our high-pressure jetter cuts through tree roots and heavy sewer blockages at the source.",
  },
  {
    title: "Emergency Blocked Drain Plumber",
    color: "#ff66c4",
    text: "Overflowing drains don't wait for business hours — and neither does our booking portal. See live availability online right now and lock in the next slot, including 7am starts. Fast response across Perth.",
  },
  {
    title: "Drain Clearing Perth",
    color: "#169ed9",
    text: "One transparent price before we start: $360 for the first hour including specialist equipment, then $45 per 15 minutes. 90% of drain clearing jobs are done within the first hour. No surprises.",
  },
  {
    title: "CCTV Drain Inspection Perth",
    color: "#adff01",
    text: "We don't just clear and leave. Our CCTV drain camera shows you exactly what caused the blockage — roots, collapse, grease — and proves it's properly cleared before we pack up.",
  },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="border-b-2 border-white/10 py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionTag number="06" label="Every Blockage We Blast" color="#adff01" />

        <Reveal>
          <h2 className="max-w-4xl font-display text-4xl uppercase leading-[0.9] tracking-tight sm:text-6xl">
            Whatever's blocking it,{" "}
            <span className="text-[#adff01]">we clear it.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="mt-6 max-w-2xl text-base leading-relaxed text-zinc-300 md:text-lg">
          <p>
            Blocked drains Perth wide — from a blocked toilet to a full sewer blockage,
            Perth searches it and we fix it. Every job booked online with upfront pricing
            and a dedicated drainage specialist.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((s, i) => (
            <Reveal key={s.title} delay={(i % 3) * 0.1} className={i === 0 ? "sm:col-span-2 lg:col-span-1" : ""}>
              <article
                data-testid={`service-card-${i}`}
                className="group flex h-full flex-col border-2 border-white/10 bg-[#121214] p-7 transition-colors"
                style={{ ["--sc"]: s.color }}
                onMouseEnter={(e) => (e.currentTarget.style.borderColor = s.color)}
                onMouseLeave={(e) => (e.currentTarget.style.borderColor = "")}
              >
                <span className="h-1 w-10" style={{ background: s.color }} />
                <h3 className="mt-5 font-display text-xl uppercase leading-tight tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-zinc-400">{s.text}</p>
                <a
                  href="#book-it-in"
                  data-testid={`service-book-${i}`}
                  className="mt-5 inline-flex items-center gap-1.5 text-xs font-extrabold uppercase tracking-[0.2em] transition-colors"
                  style={{ color: s.color }}
                >
                  Book this fix
                  <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={3} />
                </a>
              </article>
            </Reveal>
          ))}

          <Reveal delay={0.2}>
            <a
              href="#book-it-in"
              data-testid="services-book-all-card"
              className="group flex h-full flex-col justify-between border-2 border-black bg-[#ff66c4] p-7 text-black transition-transform hover:-translate-x-1 hover:-translate-y-1"
            >
              <h3 className="font-display text-2xl uppercase leading-tight tracking-tight">
                Blocked right now?
              </h3>
              <span className="mt-6 inline-flex items-center gap-2 font-display text-sm uppercase tracking-wide underline underline-offset-4">
                Book online — pick your time
                <ArrowUpRight className="h-5 w-5 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" strokeWidth={3} />
              </span>
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
